// src/components/SearchCips/SearchInput.jsx
import React from "react";

const SearchInput = React.memo(
  ({ query, onChange, onKeyDown, onFocus, placeholder, id, inputRef }) => {
    return (
      <div className="relative">
        <div className="absolute top-3 left-3 h-5 w-5 text-zinc-300"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
  <path fillRule="evenodd" d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z" clipRule="evenodd" />
</svg>
</div>
        <input
          ref={inputRef} // Attach the ref here
          autoComplete="off"
          type="search"
          id={id}
          placeholder={placeholder}
          className="peer w-full bg-white border-transparent focus:rounded-lg border-b-zinc-400 border-b-2 h-12 pl-10 pr-4 text-sm leading-5 text-zinc-900"
          onChange={onChange}
          onKeyDown={onKeyDown}
          onFocus={onFocus}
          value={query}
          aria-label="Search CIP codes"
        />
      </div>
    );
  }
);


export default SearchInput;
